import { Textarea, Button, Drawer, Group, Text, Title } from "@mantine/core"
import { notifications } from "@mantine/notifications"
import { ErrorAlert } from "../../../../../blocks/errors/error-alert"
import { Form } from "../../../../../-components/typed-form"
import { showSuccessNotification } from "../../../../../utils/form-submission-notifications"
import { useTranslations } from "../../../../../utils/use-t"

export function SetOrChangeFinalDrawer({
  mode,
  onClose,
  onSuccess,
  leaveRequestId,
}: {
  mode: "closed" | "set" | "change"
  onClose: () => void
  onSuccess: () => void
  leaveRequestId: number
}) {
  const { absences, appServer } = useTranslations()
  return (
    <Drawer
      title={
        <Title order={3}>
          {absences.t(mode == "set" ? "DecideFinally" : "ChangeFinalDecision")}
        </Title>
      }
      position="right"
      opened={mode !== "closed"}
      onClose={() => onClose()}
    >
      <Text mt="xs">
        {mode === "set"
          ? absences.t("SetFinalDecisionDescription")
          : absences.t("ChangeFinalDecisionDescription")}
      </Text>

      <Form<{ comment: string | null }, "/api/Absence/Command">
        url="/api/Absence/Command"
        options={{
          onSuccess: () => {
            onSuccess()
            onClose()
            showSuccessNotification(absences.t("ReviewedSuccessfully"))
          },
        }}
        initialValues={{ comment: null }}
        transform={(v, e) => {
          const submitter = (e!.nativeEvent as SubmitEvent).submitter
          const decision =
            submitter?.id === "approve"
              ? "Approve"
              : submitter?.id === "reject"
                ? "Reject"
                : "unknown"
          if (decision === "unknown") {
            notifications.show({
              message:
                "could not approve. This is a bug in the form. Please contact support.",
              color: "red",
            })
            throw new Error("Unknown event submitter id")
          }

          return {
            streamId: leaveRequestId,
            command: {
              Case: mode === "set" ? "SetFinalDecision" : "ChangeFinalDecision",
              Fields: { comment: v.comment, decision: { Case: decision } },
            },
          }
        }}
      >
        {(f, _, m) => (
          <>
            <ErrorAlert error={m.error} />
            <Textarea
              size="md"
              style={{ flex: 1 }}
              label={appServer.t("Comment")}
              placeholder={absences.t("ApprovalCommentPlaceholder")}
              {...f.getInputProps("comment")}
            />
            <Group align="end" mt="xs">
              <Button
                type="submit"
                variant="default"
                id="reject"
                size="md"
                loading={
                  m.isPending &&
                  m.variables?.command.Case == "ChangeFinalDecision" &&
                  m.variables.command.Fields.decision.Case === "Reject"
                }
              >
                {appServer.t("Reject")}
              </Button>
              <Button
                size="md"
                type="submit"
                variant="default"
                id="approve"
                loading={
                  m.isPending &&
                  m.variables?.command.Case == "ChangeFinalDecision" &&
                  m.variables.command.Fields.decision.Case === "Approve"
                }
              >
                {appServer.t("Approve")}
              </Button>
            </Group>
          </>
        )}
      </Form>
    </Drawer>
  )
}
